import * as Yup from 'yup';
import Market, { MarketType } from "../entities/market.entity";

export type MarketForm = Market;

export type MarketFormShape = {
  [key in keyof MarketForm]?: any
};

const prestashopField = () =>
  Yup.number()
    .when('type', {
      is: (type: MarketType) => type === MarketType.Prestashop,
      then: Yup.number().required('Campo obrigatório').typeError('Informe um valor válido'),
      otherwise: Yup.number().optional(),
    });

export const schema = Yup.object().shape<MarketFormShape>({
  label: Yup.string().required('Digite um nome para o mercado'),
  condominium: Yup.string().required('Selecione um condomínio'),
  type: Yup.string().required('Selecione um tipo'),
  marketCode: Yup.string().uppercase().length(6, 'Código de vínculo com 6 caracteres').optional().nullable(),
  prestashopCanceledStateId: prestashopField(),
  prestashopCarrierId: prestashopField(),
  prestashopCategoryParentId: prestashopField(),
  prestashopCurrencyId: prestashopField(),
  prestashopGroupShopId: prestashopField(),
  prestashopLangId: prestashopField(),
  prestashopPaidStateId: prestashopField(),
  prestashopPaymentFailedStateId: prestashopField(),
  prestashopShopId: prestashopField(),
  prestashopWaitingPaymentStateId: prestashopField(),
  prestashopModuleId: Yup.string().when('type', {
    is: (type: MarketType) => type === MarketType.Prestashop,
    then: Yup.string().required('Campo obrigatório'),
    otherwise: Yup.string().optional(),
  })
});
